export default function updateResult(m, e) {
	m.setData({
		currentTest: e.task,
		result: {
			...m.data.result,
			[e.task]: {
				...m.data.result[e.task],
				progress: e.progress || 1,
				result: e.result,
			},
		},
	});
}
